// src/tileset-manager/types.ts
var UpdateTileStrategy = /* @__PURE__ */ ((UpdateTileStrategy2) => {
  UpdateTileStrategy2["Realtime"] = "realtime";
  UpdateTileStrategy2["Overlap"] = "overlap";
  UpdateTileStrategy2["Replace"] = "replace";
  return UpdateTileStrategy2;
})(UpdateTileStrategy || {});
var LoadTileDataStatus = /* @__PURE__ */ ((LoadTileDataStatus2) => {
  LoadTileDataStatus2["Loading"] = "Loading";
  LoadTileDataStatus2["Loaded"] = "Loaded";
  LoadTileDataStatus2["Failure"] = "Failure";
  LoadTileDataStatus2["Cancelled"] = "Cancelled";
  return LoadTileDataStatus2;
})(LoadTileDataStatus || {});
export {
  LoadTileDataStatus,
  UpdateTileStrategy
};
